import { Reducer } from 'redux';
import { ActionTypes, TAuthState } from './types';

export const initialState: TAuthState = {
  loading: true,
  data: null,
  isAuth: false,
  errors: undefined,
};

const authReducer: Reducer<TAuthState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_USER:
      return { ...state, data: action.payload };

    case ActionTypes.GET_USER_R:
      return { ...state, loading: true, errors: undefined };
    case ActionTypes.SET_IS_AUTH:
      return { ...state, loading: false, errors: undefined, isAuth: action.payload };
    case ActionTypes.GET_USER_S:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errors: undefined,
      };
    case ActionTypes.GET_USER_E:
      return { ...state, loading: false, errors: action.payload };
    default:
      return state;
  }
};

export { authReducer as AuthReducer };
